import { createRouter, createWebHashHistory } from 'vue-router'
import { isMobileDevice } from '../utils/device-detect.js'

// 源-路由
const routes = [
  {
    path: '/',
    component: () => import('../view/index.vue'),
    meta: { title: '首页' },
    children: [
      // 工作台
      {
        path: '/',
        component: () => import('../modules/workbench/view/workbench-home.vue'),
        meta: { title: '工作台' }
      },
      // 我的面试
      {
        path: '/my-interview-home',
        component: () => import('../modules/my-interview/view/index.vue'),
        meta: { title: '我的面试' },
        children: [
          // 我的面试-正在进行的面试列表
          {
            path: '/my-interview-home',
            component: () => import('../modules/my-interview/view/my-interview-list.vue'),
            meta: { title: '面试日程列表' }
          },
          // 面试-历史记录
          {
            path: '/history-interview',
            component: () => import('../modules/my-interview/view/history-interview-list.vue'),
            meta: { title: '历史面试记录' }
          },
          // 面试-全部面试
          {
            path: '/all-interview',
            component: () => import('../modules/my-interview/view/all-interview-list.vue'),
            meta: { title: '全部面试' }
          },
          // 我的面试-面试方案首页
          {
            path: '/interview-flow',
            name: 'interview-flow',
            component: () => {
              if (isMobileDevice()) {
                return import('../modules/my-interview/view/mobile/interview-flow.vue')
              } else {
                return import('../modules/my-interview/view/interview-flow.vue')
              }
            },
            meta: { title: '面试方案' },
            children: [
              // 面试方案-上传简历
              {
                path: '/interview-flow',
                component: () => import('../modules/my-interview/view/interview-flow-curriculum-vitae.vue'),
                meta: { title: '面试方案-上传简历' }
              },
              // 面试方案-面试过程-初面，复面，终面
              {
                path: '/interview-flow/course',
                name: 'interview-flow-course',
                component: () => {
                  if (isMobileDevice()) {
                    return import('../modules/my-interview/view/mobile/interview-flow-course.vue')
                  } else {
                    return import('../modules/my-interview/view/interview-flow-course.vue')
                  }
                },
                meta: { title: '面试方案详情' }
              },
              {
                path: '/interview-flow/conclusion',
                component: () => {
                  if (isMobileDevice()) {
                    return import('../modules/my-interview/view/mobile/interview-summary.vue')
                  } else {
                    return import('../modules/my-interview/view/interview-conclusion.vue')
                  }
                },
                meta: { title: '面试结论（结束录音）' }
              },
              // 面试方案-面试过程-背景调查
              {
                path: '/interview-flow/investigate',
                name: 'interview-flow-investigate',
                component: () => import('../modules/my-interview/view/interview-flow-investigate.vue'),
                meta: { title: '背景调查' }
              },
              // 面试方案-面试过程-总结
              {
                path: '/interview-flow/summarize',
                name: 'interview-flow-summarize',
                component: () => import('../modules/my-interview/view/interview-flow-summarize.vue'),
                meta: { title: '面试总结' }
              },
              {
                path: '/interview-flow/assessment',
                name: 'interview-flow-assessment',
                component: () => import('../modules/my-interview/view/interview-flow-assessment.vue'),
                meta: { title: '面试测评' }
              }

            ]
          },
        ]
      },
      // 面试官问题库模板
      {
        path: '/role/interview-question-template',
        component: () => import('../modules/Interviewer-question-module/view/index.vue'),
        meta: { title: '面试问题库' },
        children: [
          {
            path: '/role/interview-question-template',
            component: () => import('../modules/Interviewer-question-module/view/question-template-table.vue'),
            meta: { title: '面试问题库' }
          } 
        ]
      },
      // 面试方案-配置
      {
        path: '/flow-config',
        component: () => import('../modules/interview-flow-module/view/index.vue'),
        meta: { title: '流程配置' },
        children: [
          // 面试方案-列表
          {
            path: '/flow-config',
            component: () => import('../modules/interview-flow-module/view/flow-table.vue'),
            meta: { title: '面试方案列表' }
          },
        ]
      },
      // 岗位画像模板
      {
        path: '/post-template',
        component: () => import('../modules/post-module/view/index.vue'),
        meta: { title: '岗位画像' },
        children: [
          // 岗位-列表
          {
            path: '/post-template',
            component: () => import('../modules/post-module/view/post-table.vue'),
            meta: { title: '岗位列表' }
          },
          // 岗位-画像详情
          {
            path: '/post/post-portrait',
            name: 'post-portrait',
            component: () => import('../modules/post-module/view/post-portrait-main.vue'),
            meta: { title: '岗位画像详情' }
          },
          
        ]
      },
      // 能力库
      {
        path: '/ability',
        name: 'ability',
        component: () => import('../modules/ability-module/view/index.vue'),
        meta: { title: '能力库' },
        children: [
          // 能力库-列表
          {
            path: '/ability',
            component: () => import('../modules/ability-module/view/ability-table.vue'),
            meta: { title: '能力列表' }
          },
        ]
      },
      // 等级库
      {
        path: '/grade',
        name: 'grade',
        component: () => import('../modules/grade-module/view/index.vue'),
        meta: { title: '等级库' },
        children: [
          {
            path: '/grade',
            component: () => import('../modules/grade-module/view/grade-table.vue'),
            meta: { title: '等级列表' }
          },
        ]
      },
      // 问题库
      {
        path: '/question',
        name: 'question',
        component: () => import('../modules/question-module/view/index.vue'),
        meta: { title: '问题库' },
        children: [
          {
            path: '/question',
            component: () => import('../modules/question-module/view/question-table.vue'),
            meta: { title: '问题列表' }
          },
        ]
      },
      // 面试质量
      {
        path: '/interview-quality',
        name: 'interview-quality',
        component: () => import('../modules/interview-quality/view/index.vue'),
        meta: { title: '面试质量' },
        children: [
          {
            path: '/interview-quality',
            component: () => import('../modules/interview-quality/view/interview-quality-main.vue'),
            meta: { title: '面试质量' }
          },
        ]
      },
      // 经验标签库
      {
        path: '/experience-tag',
        name: 'experience-tag',
        component: () => import('../modules/experience-tag-module/view/index.vue'),
        meta: { title: '经验标签库' },
        children: [
          {
            path: '/experience-tag',
            component: () => import('../modules/experience-tag-module/view/experience-tag-table.vue'),
            meta: { title: '经验标签列表' }
          },
        ]
      },
      //test
      {
        path: "/test",
        name: "test",
        component: () => import('../modules/my-interview/components/speech.vue'),
        meta: { title: '测试页面' }
      },
      // 防休眠功能测试页面
      {
        path: "/wake-lock-test",
        name: "wake-lock-test",
        component: () => import('../view/wake-lock-test.vue'),
        meta: { title: '防休眠功能测试' }
      },

      // 人才库
      {
        path: "/talents",
        component: () => import('../modules/talents-module/view/index.vue'),
        meta: { title: '人才库' },
        children: [
          {
            path: '/talents',
            component: () => import('../modules/talents-module/view/talents-table.vue'),
            meta: { title: '人才列表' }
          },
          {
            path: '/talents/collection',
            component: () => import('../modules/talents-module/view/talents-table-iscollect.vue'),
            meta: { title: '人才收藏' }
          },
          {
            path: '/talents/groups',
            component: () => import('../modules/talents-module/view/talents-table-groups.vue'),
            meta: { title: '人才分组' }
          },
          {
            path: '/talents/radar',
            component: () => import('../modules/talents-module/view/talents-radar.vue'),
            meta: { title: '人才雷达' }
          },
          //WeCom2
          {
            path: '/talents/we-com-2',
            component: () => import('../modules/talents-module/view/we-com-2.vue'),
            meta: { title: '企业微信' }
          }
        ]
      },
      // 推荐到业务方
      {
        path: "/talents-detail-view",
        component: () => import('../modules/talents-module/components/talents-detail-view.vue'),
        meta: { title: '人才详情-业务方' }
      },
      // 数据报表
      {
        path: "/data-report",
        name: "data-report",
        component: () => import('../modules/data-report/view/index.vue'),
        meta: { title: '数据报表' },
        children: [
          {
            path: '/data-report',
            component: () => import('../modules/data-report/view/data-report-home.vue'),
            meta: { title: '数据报表' }
          },
          // 自动简历库
          {
            path: "/data-report/gain-curriculum-vitae",
            component: () => import('../modules/auto-curriculum-vitae/view/index.vue'),
            meta: { title: '自动简历库' },
            children: [
              {
                path: '/data-report/gain-curriculum-vitae',
                component: () => import('../modules/auto-curriculum-vitae/view/curriculum-vitae-table.vue'),
                meta: { title: '自动找简历列表' }
              },
            ]
          },
        ]
      },
      // 智能工具
       {
        path: "/intelligent-tools",
        name: "intelligent-tools",
        component: () => import('../modules/intelligent-tools/view/index.vue'),
        meta: { title: '智能工具' },
        children: [
          {
            path: '/intelligent-tools',
            component: () => import('../modules/intelligent-tools/view/intelligent-tools-list.vue'),
            meta: { title: '智能工具' }
          },
           {
          path: '/intelligent-tools/employer-brand',
          component: () => import('../modules/employer-brand/view/employer-brand-home.vue'),
          meta: { title: '雇主品牌' }
          },
           {
            path: '/intelligent-tools/radar',
            component: () => import('../modules/talents-module/view/talents-radar.vue'),
            meta: { title: '人才雷达' }
          },
          //市场洞察
          {
          path: '/intelligent-tools/market-insight',
          component: () => import('../modules/market-insight/view/market-insight-home.vue'),
          meta: { title: '跨境职位薪资分析列表' }
        },
        // {
        //   path: '/competitor-analysis',
        //   component: () => import('../modules/market-insight/view/competitor-analysis.vue'),
        //   meta: { title: '竞对分析' }
        // },
          {
            path: '/intelligent-tools/salary-report',
            component: () => import('../modules/data-report/view/salary-report/salary-report-view.vue'),
            meta: { title: '薪酬统计报表' }
         },
        {
          path: '/intelligent-tools/insignt-view',
          component: () => import('../modules/data-report/view/insignt-view-report/insignt-view.vue'),
          meta: { title: '洞察视图表' }
        }
        ]
      },
      // 需求
      {
        path: "/interview-demand",
        name: "interview-demand",
        component: () => import('../modules/interview-demand-module/view/index.vue'),
        meta: { title: '面试方案库' },
        children: [
          {
            path: '/interview-demand',
            component: () => import('../modules/interview-demand-module/view/demand-table.vue'),
            meta: { title: '需求列表' }
          },
          {
            path: '/interview-demand/extension',
            component: () => import('../modules/interview-demand-module/view/extension.vue'),
            meta: { title: '需求页面启动插件' }
          },
          // 插件
          {
            path: '/interview-demand/plug-in',
            component: () => import('../modules/plug-in/view/index.vue'),
            meta: { title: '插件' },
            children: [
              {
                path: '/interview-demand/plug-in',
                component: () => import('../modules/plug-in/view/plug-in-home.vue'),
                meta: { title: '插件' }
              },
            ]
          },
          //简历接收邮件设置
          {
            path: '/interview-demand/gain-mail',
            name: 'mail',
            component: () => import('../modules/management-backend/view/mail/mail.vue'),
            meta: { title: '简历邮箱设置' }
          },
        ]
      },
      // 在线职位
      {
        path: "/interview-online-job",
        name: "interview-online-job",
        component: () => import('../modules/interview-onlineJob-module/view/index.vue'),
        meta: { title: '在线职位' },
        children: [
          {
            path: '/interview-online-job',
            component: () => import('../modules/interview-onlineJob-module/view/job-table.vue'),
            meta: { title: '在线职位列表' }
          },
        ]
      },
      // AI寻才
      {
        path: "/batch-hosting-demand",
        name: "batch-hosting-demand",
        component: () => import('../modules/interview-demand-module/view/batch-hosting-demand-table.vue'),
        meta: { title: 'AI寻才' },
        children: []
      },

      {
        path: "/talents-curriculum-vitae",
        name: "talents-curriculum-vitae",
        component: () => import('../modules/auto-curriculum-vitae/view/index.vue'),
        meta: { title: '人才简历库' }
      },
      // 智能评估
      {
        path: '/intelligent-assessment',
        name: 'intelligent-assessment',
        component: () => import('../modules/intelligent-assessment/view/index.vue'),
        meta: { title: '智能评估' },
        redirect: '/intelligent-assessment/test',
        children: [
          //考试
          {
            path: '/intelligent-assessment/test',
            name: 'test',
            component: () => import('../modules/intelligent-assessment/view/test/test.vue'),
            meta: { title: '考试' }
          },
          //练习
          {
            path: '/intelligent-assessment/practice',
            name: 'practice',
            component: () => import('../modules/intelligent-assessment/view/practice/practice.vue'),
            meta: { title: '练习' }
          },
          //问题库
          {
            path: '/intelligent-assessment/question-bank',
            name: 'question-bank',
            component: () => import('../modules/intelligent-assessment/view/question-bank/question-bank.vue'),
            meta: { title: '测评问题库' }
          },
          //试卷库
          {
            path: '/intelligent-assessment/test-bank',
            name: 'test-bank',
            component: () => import('../modules/intelligent-assessment/view/test-bank/test-bank.vue'),
            meta: { title: '试卷库' }
          },
          {
            path: '/intelligent-assessment/test-detail/:id',
            name: 'test-detail',
            component: () => import('../modules/intelligent-assessment/components/test-detail.vue'),
            meta: { title: '试卷详情' }
          },
          //考生
          {
            path: '/intelligent-assessment/examinee',
            name: 'examinee',
            component: () => import('../modules/intelligent-assessment/view/examinee/examinee.vue'),
            meta: { title: '考生管理' }
          }
        ]
      },
      //管理后台
      {
        path: '/management',
        name: 'management',
        component: () => import('../modules/management-backend/view/index.vue'),
        meta: { title: '管理后台' },
        redirect: '/management/member',
        children: [
          //成员管理
          {
            path: '/management/member',
            name: 'member',
            component: () => import('../modules/management-backend/view/member/member.vue'),
            meta: { title: '成员管理' }
          },
          //权限管理
          {
            path: '/management/permission',
            name: 'permission',
            component: () => import('../modules/management-backend/view/permission/permission.vue'),
            meta: { title: '权限管理' }
          },
          //第三方授权
          {
            path: '/management/third-party-auth',
            name: 'third-party-auth',
            component: () => import('../modules/management-backend/view/third-party/third-party-auth.vue'),
            meta: { title: '第三方授权' }
          },
          // 权益中心
          {
            path: '/management/equity-center',
            name: 'equity-center',
            component: () => import('../modules/management-backend/view/equity-center/equity-center.vue'),
            meta: { title: '权益中心' }
          },
          // 企业信息
          {
            path: '/management/company-info',
            name: 'company-info',
            component: () => import('../modules/management-backend/view/company-info/company-info.vue'),
            meta: { title: '企业信息' }
          },
        ]

      },
      //临时上传接口
      {
        path: '/speech-sound',
        name: 'speech-sound',
        component: () => import('../modules/my-interview/components/speech-sound.vue'),
        meta: { title: '语音上传' }
      },

    ]
  },
  {
    path: '/interviewer-examine',
    name: 'interviewer-examine',
    component: () => import('../modules/interviewer-examine/view/index.vue'),
    meta: { title: '面试官审核' }
  },
  {
    path: '/interviewer-use-examine',
    name: 'interviewer--use-examine',
    component: () => import('../modules/interviewer-examine/view/examine.vue'),
    meta: { title: '面试官使用审核' }
  },
  //用户填写成功界面
  {
    path: '/success',
    name: 'success',
    component: () => import('../modules/interviewer-examine/view/success.vue'),
    meta: { title: '考生提交测评成功' }
  },
  //登录
  {
    path: '/login',
    name: 'login',
    component: () => import('../view/login/login.vue'),
    meta: { title: '登录' }
  },
  // 微信浏览器提示页
  {
    path: '/wechat-browser',
    name: 'wechat-browser',
    component: () => import('../view/weChat-browser.vue'),
    meta: { title: '请使用系统浏览器' }
  },
  //桌面端流程配置
  {
    path: '/electron-flow-home',
    name: 'electron-flow-home',
    component: () => import('../view/electron-flow-home.vue'),
    meta: { title: '桌面端流程配置' }
  },
  {
    path: '/electron-bootstrap',
    name: 'electron-bootstrap',
    component: () => import('../view/electron-bootstrap.vue'),
    meta: { title: '桌面端引导' }
  },
  //桌面端到浏览器中间页
  {
    path: '/electron-centre-home',
    name: 'electron-centre-home',
    component: () => import('../view/electron-centre-home.vue'),
    meta: { title: '桌面端中间页' }
  },
  //桌面端到Guacamole中间页
  {
    path: '/electron-centre-guacamole-home',
    name: 'electron-centre-guacamole-home',
    component: () => import('../view/electron-centre-guacamole-home.vue'),
    meta: { title: '桌面端Guacamole中间页' }
  },
  //桌面端到Guacamole中间页
  {
    path: '/electron-centre-batch-home',
    name: 'electron-centre-batch-home',
    component: () => import('../view/electron-centre-batch-home.vue'),
    meta: { title: '桌面端AI寻才中间页' }
  },
  //桌面端到同步中间页
  {
    path: '/electron-centre-synchronize-home',
    name: 'electron-centre-synchronize-home',
    component: () => import('../view/electron-centre-synchronize-home.vue'),
    meta: { title: '桌面端同步中间页' }
  },
  //桌面端到工作台
  {
    path: '/electron-workbench-home',
    name: 'electron-workbench-home',
    component: () => import('../view/electron-flow-workbench-home.vue'),
    meta: { title: '桌面端工作台' }
  },
  // 企业微信登录入口
  {
    path: '/wechat-enterprise-entry',
    name: 'wechat-enterprise-entry',
    component: () => import('../view/login/wechat-enterprise-entry.vue'),
    meta: { title: '企业微信登录' }
  },
  // 企业微信登录回调
  {
    path: '/social-callback',
    name: 'wechat-enterprise-callback',
    component: () => import('../view/login/wechat-enterprise-callback.vue'),
    meta: { title: '企业微信登录' }
  },

]

// 动态路由 - 需要根据权限动态添加的路由
const asyncRoutes = [
  // 我的面试
  {
    path: '/my-interview-home',
    component: () => import('../modules/my-interview/view/index.vue'),
    meta: { title: '我的面试' },
    children: [
      // 我的面试-正在进行的面试列表
      {
        path: '/my-interview-home',
        component: () => import('../modules/my-interview/view/my-interview-list.vue'),
        meta: { title: '面试日程列表' }
      },
      // 面试-历史记录
      {
        path: '/history-interview',
        component: () => import('../modules/my-interview/view/history-interview-list.vue'),
        meta: { title: '历史面试记录' }
      },
      // 面试-全部面试
      {
        path: '/all-interview',
        component: () => import('../modules/my-interview/view/all-interview-list.vue'),
        meta: { title: '全部面试' }
      },
      // 面试官列表
      {
        path: '/role/role-interview',
        name: 'role-interview',
        component: () => {
          if (isMobileDevice()) {
            return import('../modules/my-interview/view/mobile/role-interview-list.vue')
          } else {
            return import('../modules/my-interview/view/role-interview-list.vue')
          }
        },
        meta: { title: '面试官列表' }
      },
      // 我的面试-面试方案首页
      {
        path: '/interview-flow',
        name: 'interview-flow',
        component: () => {
          if (isMobileDevice()) {
            return import('../modules/my-interview/view/mobile/interview-flow.vue')
          } else {
            return import('../modules/my-interview/view/interview-flow.vue')
          }
        },
        meta: { title: '面试方案' },
        children: [
          // 面试方案-上传简历
          {
            path: '/interview-flow',
            component: () => import('../modules/my-interview/view/interview-flow-curriculum-vitae.vue'),
            meta: { title: '面试方案-上传简历' }
          },
          // 面试方案-面试过程-初面，复面，终面
          {
            path: '/interview-flow/course',
            name: 'interview-flow-course',
            component: () => {
              if (isMobileDevice()) {
                return import('../modules/my-interview/view/mobile/interview-flow-course.vue')
              } else {
                return import('../modules/my-interview/view/interview-flow-course.vue')
              }
            },
            meta: { title: '面试方案详情' }
          },
          {
            path: '/interview-flow/conclusion',
            component: () => {
              if (isMobileDevice()) {
                return import('../modules/my-interview/view/mobile/interview-summary.vue')
              } else {
                return import('../modules/my-interview/view/interview-conclusion.vue')
              }
            },
            meta: { title: '面试结论（结束录音）' }
          },
          // 面试方案-面试过程-背景调查
          {
            path: '/interview-flow/investigate',
            component: () => import('../modules/my-interview/view/interview-flow-investigate.vue'),
            meta: { title: '背景调查' }
          },
          // 面试方案-面试过程-总结
          {
            path: '/interview-flow/summarize',
            component: () => import('../modules/my-interview/view/interview-flow-summarize.vue'),
            meta: { title: '面试总结' }
          },
          {
            path: '/interview-flow/assessment',
            component: () => import('../modules/my-interview/view/interview-flow-assessment.vue'),
            meta: { title: '面试测评' }
          }

        ]
      },
    ]
  },
  // 面试方案-配置
  {
    path: '/flow-config',
    component: () => import('../modules/interview-flow-module/view/index.vue'),
    meta: { title: '流程配置' },
    children: [
      // 面试方案-列表
      {
        path: '/flow-config',
        component: () => import('../modules/interview-flow-module/view/flow-table.vue'),
        meta: { title: '面试方案列表' }
      },
    ]
  },
  // 岗位画像模板
  {
    path: '/post-template',
    component: () => import('../modules/post-module/view/index.vue'),
    meta: { title: '岗位画像' },
    children: [
      // 岗位-列表
      {
        path: '/post-template',
        component: () => import('../modules/post-module/view/post-table.vue'),
        meta: { title: '岗位列表' }
      },
      // 岗位-画像详情
      {
        path: '/post/post-portrait',
        component: () => import('../modules/post-module/view/post-portrait-main.vue'),
        meta: { title: '岗位画像详情' }
      },

    ]
  },
  // 能力库
  {
    path: '/ability',
    component: () => import('../modules/ability-module/view/index.vue'),
    meta: { title: '能力库' },
    children: [
      // 能力库-列表
      {
        path: '/ability',
        component: () => import('../modules/ability-module/view/ability-table.vue'),
        meta: { title: '能力列表' }
      },
    ]
  },
  // 等级库
  {
    path: '/grade',
    component: () => import('../modules/grade-module/view/index.vue'),
    meta: { title: '等级库' },
    children: [
      {
        path: '/grade',
        component: () => import('../modules/grade-module/view/grade-table.vue'),
        meta: { title: '等级列表' }
      },
    ]
  },
  // 问题库
  {
    path: '/question',
    component: () => import('../modules/question-module/view/index.vue'),
    meta: { title: '问题库' },
    children: [
      {
        path: '/question',
        component: () => import('../modules/question-module/view/question-table.vue'),
        meta: { title: '问题列表' }
      },
    ]
  },
  // 面试质量
  {
    path: '/interview-quality',
    name: 'interview-quality',
    component: () => import('../modules/interview-quality/view/index.vue'),
    meta: { title: '面试质量' },
    children: [
      {
        path: '/interview-quality',
        component: () => import('../modules/interview-quality/view/interview-quality-main.vue'),
        meta: { title: '面试质量' }
      },
    ]
  },
  // 经验标签库
  {
    path: '/experience-tag',
    component: () => import('../modules/experience-tag-module/view/index.vue'),
    meta: { title: '经验标签库' },
    children: [
      {
        path: '/experience-tag',
        component: () => import('../modules/experience-tag-module/view/experience-tag-table.vue'),
        meta: { title: '经验标签列表' }
      },
    ]
  },
  //test
  {
    path: "/test",
    component: () => import('../modules/my-interview/components/speech.vue'),
    meta: { title: '测试页面' }
  },
  // 人才库
  {
    path: "/talents",
    component: () => import('../modules/talents-module/view/index.vue'),
    meta: { title: '人才库' },
    children: [
      {
        path: '/talents',
        component: () => import('../modules/talents-module/view/talents-table.vue'),
        meta: { title: '人才列表' }
      },
      {
        path: '/talents/collection',
        component: () => import('../modules/talents-module/view/talents-table-iscollect.vue'),
        meta: { title: '人才收藏' }
      },
      {
        path: '/talents/groups',
        component: () => import('../modules/talents-module/view/talents-table-groups.vue'),
        meta: { title: '人才分组' }
      },
      {
        path: '/talents/radar',
        component: () => import('../modules/talents-module/view/talents-radar.vue'),
        meta: { title: '人才雷达' }
      },
      //WeCom2
      {
        path: '/talents/we-com-2',
        component: () => import('../modules/talents-module/view/we-com-2.vue'),
        meta: { title: '企业微信' }
      }
    ]
  },
  // 推荐到业务方
  {
    path: "/talents-detail-view",
    component: () => import('../modules/talents-module/components/talents-detail-view.vue'),
    meta: { title: '人才详情-业务方' }
  },

  // 数据报表
  {
    path: "/data-report",
    component: () => import('../modules/data-report/view/index.vue'),
    meta: { title: '数据报表' },
    children: [
      {
        path: '/data-report',
        component: () => import('../modules/data-report/view/data-report-home.vue'),
        meta: { title: '数据报表' }
      },
      // 自动简历库
      {
        path: "/data-report/gain-curriculum-vitae",
        component: () => import('../modules/auto-curriculum-vitae/view/index.vue'),
        meta: { title: '自动简历库' },
        children: [
          {
            path: '/data-report/gain-curriculum-vitae',
            component: () => import('../modules/auto-curriculum-vitae/view/curriculum-vitae-table.vue'),
            meta: { title: '自动找简历列表' }
          },
        ]
      },
    ]
  },
  // 智能工具
       {
        path: "/intelligent-tools",
        name: "intelligent-tools",
        component: () => import('../modules/intelligent-tools/view/index.vue'),
        meta: { title: '智能工具' },
        children: [
          {
            path: '/intelligent-tools',
            component: () => import('../modules/intelligent-tools/view/intelligent-tools-list.vue'),
            meta: { title: '智能工具' }
          },
           {
          path: '/intelligent-tools/employer-brand',
          component: () => import('../modules/employer-brand/view/employer-brand-home.vue'),
          meta: { title: '雇主品牌' }
          },
           {
            path: '/intelligent-tools/radar',
            component: () => import('../modules/talents-module/view/talents-radar.vue'),
            meta: { title: '人才雷达' }
          },
          //市场洞察
          {
          path: '/intelligent-tools/market-insight',
          component: () => import('../modules/market-insight/view/market-insight-home.vue'),
          meta: { title: '跨境职位薪资分析列表' }
        },
        // {
        //   path: '/competitor-analysis',
        //   component: () => import('../modules/market-insight/view/competitor-analysis.vue'),
        //   meta: { title: '竞对分析' }
        // },
          {
            path: '/intelligent-tools/salary-report',
            component: () => import('../modules/data-report/view/salary-report/salary-report-view.vue'),
            meta: { title: '薪酬统计报表' }
         },
        {
          path: '/intelligent-tools/insignt-view',
          component: () => import('../modules/data-report/view/insignt-view-report/insignt-view.vue'),
          meta: { title: '洞察视图表' }
        }
        ]
      },
  // 面试方案库
  {
    path: "/interview-demand",
    component: () => import('../modules/interview-demand-module/view/index.vue'),
    meta: { title: '面试方案库' },
    children: [
      {
        path: '/interview-demand',
        component: () => import('../modules/interview-demand-module/view/demand-table.vue'),
        meta: { title: '需求列表' }
      },
      {
        path: '/interview-demand/extension',
        component: () => import('../modules/interview-demand-module/view/extension.vue'),
        meta: { title: '需求页面启动插件' }
      },
      // 插件
      {
        path: '/interview-demand/plug-in',
        component: () => import('../modules/plug-in/view/index.vue'),
        meta: { title: '插件' },
        children: [
          {
            path: '/interview-demand/plug-in',
            component: () => import('../modules/plug-in/view/plug-in-home.vue'),
            meta: { title: '插件' }
          },
        ]
      },
      //简历接收邮件设置
      {
        path: '/interview-demand/gain-mail',
        component: () => import('../modules/management-backend/view/mail/mail.vue'),
        meta: { title: '简历邮箱设置' }
      },
    ]
  },
  // 在线职位
  {
    path: "/interview-online-job",
    name: "interview-online-job",
    component: () => import('../modules/interview-onlineJob-module/view/index.vue'),
    meta: { title: '在线职位' },
    children: [
      {
        path: '/interview-online-job',
        component: () => import('../modules/interview-onlineJob-module/view/job-table.vue'),
        meta: { title: '在线职位列表' }
      },
    ]
  },
  // AI寻才面试方案
  {
    path: "/batch-hosting-demand",
    name: "batch-hosting-demand",
    component: () => {
      if(isMobileDevice()){
        return import('../modules/interview-demand-module/view/mobile/batch-hosting-demand-table.vue')
      } else {
        return import('../modules/interview-demand-module/view/batch-hosting-demand-table.vue')
      }
    },
    meta: { title: 'AI寻才面试方案' },
    children: []
  },
  // 人才简历库
  {
    path: "/talents-curriculum-vitae",
    component: () => import('../modules/auto-curriculum-vitae/view/index.vue'),
    meta: { title: '人才简历库' }
  },
  // 智能评估
  {
    path: '/intelligent-assessment',
    component: () => import('../modules/intelligent-assessment/view/index.vue'),
    meta: { title: '智能评估' },
    redirect: '/intelligent-assessment/test',
    children: [
      //考试
      {
        path: '/intelligent-assessment/test',
        component: () => import('../modules/intelligent-assessment/view/test/test.vue'),
        meta: { title: '考试' }
      },
      //练习
      {
        path: '/intelligent-assessment/practice',
        component: () => import('../modules/intelligent-assessment/view/practice/practice.vue'),
        meta: { title: '练习' }
      },
      //问题库
      {
        path: '/intelligent-assessment/question-bank',
        component: () => import('../modules/intelligent-assessment/view/question-bank/question-bank.vue'),
        meta: { title: '测评问题库' }
      },
      //试卷库
      {
        path: '/intelligent-assessment/test-bank',
        component: () => import('../modules/intelligent-assessment/view/test-bank/test-bank.vue'),
        meta: { title: '试卷库' }
      },
      {
        path: '/intelligent-assessment/test-detail/:id',
        component: () => import('../modules/intelligent-assessment/components/test-detail.vue'),
        meta: { title: '试卷详情' }
      },
      //考生
      {
        path: '/intelligent-assessment/examinee',
        component: () => import('../modules/intelligent-assessment/view/examinee/examinee.vue'),
        meta: { title: '考生管理' }
      }
    ]
  },

]


// 根据设备类型生成静态路由
const getConstantRoutes = () => {
  const isMobile = isMobileDevice()
  const layoutComponent = isMobile 
    ? () => import('../view/mobile-index.vue')
    : () => import('../view/index.vue')
  
  return [
    {
      path: '/',
      component: layoutComponent,
      meta: { title: '首页' },
      children: [
      
      // 我的面试
      {
        path: '/my-interview-home',
        component: () => import('../modules/my-interview/view/index.vue'),
        meta: { title: '我的面试' },
        children: [
          // 我的面试-正在进行的面试列表
          {
            path: '/my-interview-home',
            component: () => import('../modules/my-interview/view/my-interview-list.vue'),
            meta: { title: '面试日程列表' }
          },
          // 面试-历史记录
          {
            path: '/history-interview',
            component: () => import('../modules/my-interview/view/history-interview-list.vue'),
            meta: { title: '历史面试记录' }
          },
          // 面试-全部面试
          {
            path: '/all-interview',
            component: () => import('../modules/my-interview/view/all-interview-list.vue'),
            meta: { title: '全部面试' }
          },
          // 面试官列表
          {
            path: '/role/role-interview',
            name: 'role-interview',
            component: () => {
              if (isMobileDevice()) {
                return import('../modules/my-interview/view/mobile/role-interview-list.vue')
              } else {
                return import('../modules/my-interview/view/role-interview-list.vue')
              }
            },
            meta: { title: '面试官列表' }
          },
          // 面试官问题库模板
          {
            path: '/role/interview-question-template',
            component: () => import('../modules/Interviewer-question-module/view/index.vue'),
            meta: { title: '面试问题库' },
            children: [
              {
                path: '/role/interview-question-template',
                component: () => import('../modules/Interviewer-question-module/view/question-template-table.vue'),
                meta: { title: '面试问题库' }
              },
              {
                path: '/role/interview-question-template/main',
                component: () => import('../modules/Interviewer-question-module/view/question-template-main.vue'),
                meta: { title: '面试问题模板详情' }
              }
            ]
          },
          // 我的面试-面试方案首页
          {
            path: '/interview-flow',
            name: 'interview-flow',
            component: () => {
              if (isMobileDevice()) {
                return import('../modules/my-interview/view/mobile/interview-flow.vue')
              } else {
                return import('../modules/my-interview/view/interview-flow.vue')
              }
            },
            meta: { title: '面试方案' },
            children: [
              // 面试方案-上传简历
              {
                path: '/interview-flow',
                component: () => import('../modules/my-interview/view/interview-flow-curriculum-vitae.vue'),
                meta: { title: '面试方案-上传简历' }
              },
              // 面试方案-面试过程-初面，复面，终面
              {
                path: '/interview-flow/course',
                name: 'interview-flow-course',
                component: () => {
                  if (isMobileDevice()) {
                    return import('../modules/my-interview/view/mobile/interview-flow-course.vue')
                  } else {
                    return import('../modules/my-interview/view/interview-flow-course.vue')
                  }
                },
                meta: { title: '面试方案详情' }
              },
              {
                path: '/interview-flow/conclusion',
                component: () => {
                  if (isMobileDevice()) {
                    return import('../modules/my-interview/view/mobile/interview-summary.vue')
                  } else {
                    return import('../modules/my-interview/view/interview-conclusion.vue')
                  }
                },
                meta: { title: '面试结论（结束录音）' }
              },
              // 面试方案-面试过程-背景调查
              {
                path: '/interview-flow/investigate',
                component: () => import('../modules/my-interview/view/interview-flow-investigate.vue'),
                meta: { title: '背景调查' }
              },
              // 面试方案-面试过程-总结
              {
                path: '/interview-flow/summarize',
                component: () => import('../modules/my-interview/view/interview-flow-summarize.vue'),
                meta: { title: '面试总结' }
              },
              {
                path: '/interview-flow/assessment',
                component: () => import('../modules/my-interview/view/interview-flow-assessment.vue'),
                meta: { title: '面试测评' }
              }

            ]
          },
        ]
      },
      // 面试方案-配置
      {
        path: '/flow-config',
        component: () => import('../modules/interview-flow-module/view/index.vue'),
        meta: { title: '流程配置' },
        children: [
          // 面试方案-列表
          {
            path: '/flow-config',
            component: () => import('../modules/interview-flow-module/view/flow-table.vue'),
            meta: { title: '面试方案列表' }
          },
        ]
      },
      // 岗位画像模板
      {
        path: '/post-template',
        component: () => import('../modules/post-module/view/index.vue'),
        meta: { title: '岗位画像' },
        children: [
          // 岗位-列表
          {
            path: '/post-template',
            component: () => import('../modules/post-module/view/post-table.vue'),
            meta: { title: '岗位列表' }
          },
          // 岗位-画像详情
          {
            path: '/post/post-portrait',
            component: () => import('../modules/post-module/view/post-portrait-main.vue'),
            meta: { title: '岗位画像详情' }
          },

        ]
      },
      // 能力库
      {
        path: '/ability',
        component: () => import('../modules/ability-module/view/index.vue'),
        meta: { title: '能力库' },
        children: [
          // 能力库-列表
          {
            path: '/ability',
            component: () => import('../modules/ability-module/view/ability-table.vue'),
            meta: { title: '能力列表' }
          },
        ]
      },
      // 等级库
      {
        path: '/grade',
        component: () => import('../modules/grade-module/view/index.vue'),
        meta: { title: '等级库' },
        children: [
          {
            path: '/grade',
            component: () => import('../modules/grade-module/view/grade-table.vue'),
            meta: { title: '等级列表' }
          },
        ]
      },
      // 问题库
      {
        path: '/question',
        component: () => import('../modules/question-module/view/index.vue'),
        meta: { title: '问题库' },
        children: [
          {
            path: '/question',
            component: () => import('../modules/question-module/view/question-table.vue'),
            meta: { title: '问题列表' }
          },
        ]
      },
      // 面试质量
      {
        path: '/interview-quality',
        name: 'interview-quality',
        component: () => import('../modules/interview-quality/view/index.vue'),
        meta: { title: '面试质量' },
        children: [
          {
            path: '/interview-quality',
            component: () => import('../modules/interview-quality/view/interview-quality-main.vue'),
            meta: { title: '面试质量' }
          },
        ]
      },
      // 经验标签库
      {
        path: '/experience-tag',
        component: () => import('../modules/experience-tag-module/view/index.vue'),
        meta: { title: '经验标签库' },
        children: [
          {
            path: '/experience-tag',
            component: () => import('../modules/experience-tag-module/view/experience-tag-table.vue'),
            meta: { title: '经验标签列表' }
          },
        ]
      },
      //test
      {
        path: "/test",
        component: () => import('../modules/my-interview/components/speech.vue'),
        meta: { title: '测试页面' }
      },
      // 人才库
      {
        path: "/talents",
        component: () => import('../modules/talents-module/view/index.vue'),
        meta: { title: '人才库' },
        children: [
          {
            path: '/talents',
            component: () => import('../modules/talents-module/view/talents-table.vue'),
            meta: { title: '人才列表' }
          },
          {
            path: '/talents/collection',
            component: () => import('../modules/talents-module/view/talents-table-iscollect.vue'),
            meta: { title: '人才收藏' }
          },
          {
            path: '/talents/groups',
            component: () => import('../modules/talents-module/view/talents-table-groups.vue'),
            meta: { title: '人才分组' }
          },
          {
            path: '/talents/radar',
            component: () => import('../modules/talents-module/view/talents-radar.vue'),
            meta: { title: '人才雷达' }
          },
          //WeCom2
          {
            path: '/talents/we-com-2',
            component: () => import('../modules/talents-module/view/we-com-2.vue'),
            meta: { title: '企业微信' }
          }
        ]
      },
      // 推荐到业务方
      {
        path: "/talents-detail-view",
        component: () => {
          if(isMobileDevice()){
            return import('../modules/talents-module/view/mobile/talents-detail-view.vue')
          } else {
            return import('../modules/talents-module/components/talents-detail-view.vue')
          }
        },
        meta: { title: '人才详情-业务方' }
      },
      // 数据报表
      {
        path: "/data-report",
        component: () => import('../modules/data-report/view/index.vue'),
        meta: { title: '数据报表' },
        children: [
          {
            path: '/data-report',
            component: () => import('../modules/data-report/view/data-report-home.vue'),
            meta: { title: '数据报表' }
          },
          // 自动简历库
          {
            path: "/data-report/gain-curriculum-vitae",
            component: () => import('../modules/auto-curriculum-vitae/view/index.vue'),
            meta: { title: '自动简历库' },
            children: [
              {
                path: '/data-report/gain-curriculum-vitae',
                component: () => import('../modules/auto-curriculum-vitae/view/curriculum-vitae-table.vue'),
                meta: { title: '自动找简历列表' }
              },
            ]
          },
          {
            path: '/data-report/demand-progress',
            component: () => import('../modules/data-report/view/demand-progress/demand-progress-view.vue'),
            meta: { title: '招聘职位进度管理报表' }
          },
          {
            path: '/data-report/salary-report',
            component: () => import('../modules/data-report/view/salary-report/salary-report-view.vue'),
            meta: { title: '薪酬统计报表' }
          },
          {
            path: '/data-report/hr-progress',
            component: () => import('../modules/data-report/view/hr-chart-report/hr-progress-view.vue'),
            meta: { title: 'HR招聘详情表' }
          },
          {
            path: '/data-report/insignt-view',
            component: () => import('../modules/data-report/view/insignt-view-report/insignt-view.vue'),
            meta: { title: '洞察视图表' }
          }
        ]
      },
      // 智能工具
       {
        path: "/intelligent-tools",
        name: "intelligent-tools",
        component: () => import('../modules/intelligent-tools/view/index.vue'),
        meta: { title: '智能工具' },
        children: [
          {
            path: '/intelligent-tools',
            component: () => import('../modules/intelligent-tools/view/intelligent-tools-list.vue'),
            meta: { title: '智能工具' }
          },
           {
          path: '/intelligent-tools/employer-brand',
          component: () => import('../modules/employer-brand/view/employer-brand-home.vue'),
          meta: { title: '雇主品牌' }
          },
           {
            path: '/intelligent-tools/radar',
            component: () => import('../modules/talents-module/view/talents-radar.vue'),
            meta: { title: '人才雷达' }
          },
          //市场洞察
          {
          path: '/intelligent-tools/market-insight',
          component: () => import('../modules/market-insight/view/market-insight-home.vue'),
          meta: { title: '跨境职位薪资分析列表' }
        },
        // {
        //   path: '/competitor-analysis',
        //   component: () => import('../modules/market-insight/view/competitor-analysis.vue'),
        //   meta: { title: '竞对分析' }
        // },
          {
            path: '/intelligent-tools/salary-report',
            component: () => import('../modules/data-report/view/salary-report/salary-report-view.vue'),
            meta: { title: '薪酬统计报表' }
         },
        {
          path: '/intelligent-tools/insignt-view',
          component: () => import('../modules/data-report/view/insignt-view-report/insignt-view.vue'),
          meta: { title: '洞察视图表' }
        }
        ]
      },
      // 面试方案库
      {
        path: "/interview-demand",
        component: () => import('../modules/interview-demand-module/view/index.vue'),
        meta: { title: '面试方案库' },
        children: [
          {
            path: '/interview-demand',
            component: () => import('../modules/interview-demand-module/view/demand-table.vue'),
            meta: { title: '需求列表' }
          },
          {
            path: '/interview-demand/extension',
            component: () => import('../modules/interview-demand-module/view/extension.vue'),
            meta: { title: '需求页面启动插件' }
          },
          // 插件
          {
            path: '/interview-demand/plug-in',
            component: () => import('../modules/plug-in/view/index.vue'),
            meta: { title: '插件' },
            children: [
              {
                path: '/interview-demand/plug-in',
                component: () => import('../modules/plug-in/view/plug-in-home.vue'),
                meta: { title: '插件' }
              },
            ]
          },
          //简历接收邮件设置
          {
            path: '/interview-demand/gain-mail',
            component: () => import('../modules/management-backend/view/mail/mail.vue'),
            meta: { title: '简历邮箱设置' }
          },
        ]
      },
      // 在线职位
      {
        path: "/interview-online-job",
        name: "interview-online-job",
        component: () => import('../modules/interview-onlineJob-module/view/index.vue'),
        meta: { title: '在线职位' },
        children: [
          {
            path: '/interview-online-job',
            component: () => import('../modules/interview-onlineJob-module/view/job-table.vue'),
            meta: { title: '在线职位列表' }
          },
        ]
      },
      // AI寻才面试方案
      {
        path: "/batch-hosting-demand",
        name: "batch-hosting-demand",
        component: () => {
          if(isMobileDevice()){
            return import('../modules/interview-demand-module/view/mobile/batch-hosting-demand-table.vue')
          } else {
            return import('../modules/interview-demand-module/view/batch-hosting-demand-table.vue')
          }
        },
        meta: { title: 'AI寻才面试方案' },
        children: []
      },
      // 人才简历库
      {
        path: "/talents-curriculum-vitae",
        component: () => import('../modules/auto-curriculum-vitae/view/index.vue'),
        meta: { title: '人才简历库' }
      },
      // 智能评估
      {
        path: '/intelligent-assessment',
        component: () => import('../modules/intelligent-assessment/view/index.vue'),
        meta: { title: '智能评估' },
        redirect: '/intelligent-assessment/test',
        children: [
          //考试
          {
            path: '/intelligent-assessment/test',
            component: () => import('../modules/intelligent-assessment/view/test/test.vue'),
            meta: { title: '考试' }
          },
          //练习
          {
            path: '/intelligent-assessment/practice',
            component: () => import('../modules/intelligent-assessment/view/practice/practice.vue'),
            meta: { title: '练习' }
          },
          //问题库
          {
            path: '/intelligent-assessment/question-bank',
            component: () => import('../modules/intelligent-assessment/view/question-bank/question-bank.vue'),
            meta: { title: '测评问题库' }
          },
          //试卷库
          {
            path: '/intelligent-assessment/test-bank',
            component: () => import('../modules/intelligent-assessment/view/test-bank/test-bank.vue'),
            meta: { title: '试卷库' }
          },
          {
            path: '/intelligent-assessment/test-detail/:id',
            component: () => import('../modules/intelligent-assessment/components/test-detail.vue'),
            meta: { title: '试卷详情' }
          },
          //考生
          {
            path: '/intelligent-assessment/examinee',
            component: () => import('../modules/intelligent-assessment/view/examinee/examinee.vue'),
            meta: { title: '考生管理' }
          }
        ]
      },
      // 工作台
      {
        path: '/',
        component: () => import('../modules/workbench/view/workbench-home.vue'),
        meta: { title: '工作台' }
      },
      //管理后台
      {
        path: '/management',
        name: 'management',
        component: () => import('../modules/management-backend/view/index.vue'),
        meta: { title: '管理后台' },
        redirect: '/management/member',
        children: [
          //成员管理
          {
            path: '/management/member',
            name: 'member',
            component: () => import('../modules/management-backend/view/member/member.vue'),
            meta: { title: '成员管理' }
          },
          //权限管理
          {
            path: '/management/permission',
            name: 'permission',
            component: () => import('../modules/management-backend/view/permission/permission.vue'),
            meta: { title: '权限管理' }
          },
          //第三方授权
          {
            path: '/management/third-party-auth',
            name: 'third-party-auth',
            component: () => import('../modules/management-backend/view/third-party/third-party-auth.vue'),
            meta: { title: '第三方授权' }
          },
          // 权益中心
          {
            path: '/management/equity-center',
            name: 'equity-center',
            component: () => import('../modules/management-backend/view/equity-center/equity-center.vue'),
            meta: { title: '权益中心' }
          },
          // 企业信息
          {
            path: '/management/company-info',
            name: 'company-info',
            component: () => import('../modules/management-backend/view/company-info/company-info.vue'),
            meta: { title: '企业信息' }
          },
        ]

      },
      //临时上传接口
      {
        path: '/speech-sound',
        name: 'speech-sound',
        component: () => import('../modules/my-interview/components/speech-sound.vue'),
        meta: { title: '语音上传' }
      },
    ]
  },
  //对话式引导
  {
    path: '/global-guide',
    name: 'global-guide',
    component: () => import('../modules/global-guide-module/view/global-guide.vue'),
    meta: { title: '对话式引导' }
  },
  {
    path: '/interviewer-examine',
    name: 'interviewer-examine',
    component: () => import('../modules/interviewer-examine/view/index.vue'),
    meta: { title: '面试官审核' }
  },
  {
    path: '/interviewer-use-examine',
    name: 'interviewer--use-examine',
    component: () => import('../modules/interviewer-examine/view/examine.vue'),
    meta: { title: '面试官使用审核' }
  },
  //用户填写成功界面
  {
    path: '/success',
    name: 'success',
    component: () => import('../modules/interviewer-examine/view/success.vue'),
    meta: { title: '考生提交测评成功' }
  },
  //登录
  {
    path: '/login',
    name: 'login',
    component: () => import('../view/login/login.vue'),
    meta: { title: '登录' }
  },
  // 微信浏览器提示页
  {
    path: '/wechat-browser',
    name: 'wechat-browser',
    component: () => import('../view/weChat-browser.vue'),
    meta: { title: '请使用系统浏览器' }
  },
  // 钉钉登录入口
  {
    path: '/dingtalk-login',
    name: 'dingtalk-login',
    component: () => import('../view/login/login.vue'),
    meta: { title: '钉钉登录' },
    props: route => ({
      corpId: route.query.corpId
    })
  },
  //桌面端流程配置
  {
    path: '/electron-flow-home',
    name: 'electron-flow-home',
    component: () => import('../view/electron-flow-home.vue'),
    meta: { title: '桌面端流程配置' }
  },
  {
    path: '/electron-bootstrap',
    name: 'electron-bootstrap',
    component: () => import('../view/electron-bootstrap.vue'),
    meta: { title: '桌面端引导' }
  },
  //桌面端到浏览器中间页
  {
    path: '/electron-centre-home',
    name: 'electron-centre-home',
    component: () => import('../view/electron-centre-home.vue'),
    meta: { title: '桌面端中间页' }
  },
  //桌面端到Guacamole中间页
  {
    path: '/electron-centre-guacamole-home',
    name: 'electron-centre-guacamole-home',
    component: () => import('../view/electron-centre-guacamole-home.vue'),
    meta: { title: '桌面端Guacamole中间页' }
  },
  //桌面端到AI寻才中间页
  {
    path: '/electron-centre-batch-home',
    name: 'electron-centre-batch-home',
    component: () => import('../view/electron-centre-batch-home.vue'),
    meta: { title: '桌面端AI寻才中间页' }
  },
  //桌面端到同步中间页
  {
    path: '/electron-centre-synchronize-home',
    name: 'electron-centre-synchronize-home',
    component: () => import('../view/electron-centre-synchronize-home.vue'),
    meta: { title: '桌面端同步中间页' }
  },
  //桌面端到工作台
  {
    path: '/electron-workbench-home',
    name: 'electron-workbench-home',
    component: () => import('../view/electron-flow-workbench-home.vue'),
    meta: { title: '桌面端工作台' }
  },
  // 企业微信登录入口
  {
    path: '/wechat-enterprise-entry',
    name: 'wechat-enterprise-entry',
    component: () => import('../view/login/wechat-enterprise-entry.vue'),
    meta: { title: '企业微信登录' }
  },
  // 企业微信登录回调
  {
    path: '/social-callback',
    name: 'social-callback',
    component: () => import('../view/login/wechat-enterprise-callback.vue'),
    meta: { title: '企业微信登录' }
  },
  // 企业微信登录回调
  {
    path: '/wechat-talents',
    name: 'wechat-talents',
    component: () => import('../modules/talents-module/view/weCom-talents-table.vue'),
    meta: { title: '企业微信人才列表' }
  },
  // 企业微信移动端人才列表
  {
    path: '/weCom-mobile-table',
    name: 'weCom-mobile-table',
    component: () => import('../modules/talents-module/view/weCom-mobile-table.vue'),
    meta: { title: '企业微信人才列表' }
  },
  // 飞书登录入口
  {
    path: '/lark-enterprise-entry',
    name: 'lark-enterprise-entry',
    component: () => import('../view/login/lark-enterprise-entry.vue'),
    meta: { title: '飞书登录' }
  },
  // 飞书登录回调
  {
    path: '/lark-enterprise-callback',
    name: 'lark-enterprise-callback',
    component: () => import('../view/login/lark-enterprise-callback.vue'),
    meta: { title: '飞书登录' }
  },
  // 远端窗口登录
  {
    path: '/remote-window-login',
    name: 'remote-window-login',
    component: () => import('../view/login/remote-window-login.vue'),
    meta: { title: '远端窗口登录' }
  },
  // 钉钉登录入口
  {
    path: '/dingtalk-enterprise-entry',
    name: 'dingtalk-enterprise-entry',
    component: () => import('../view/login/dingtalk-enterprise-entry.vue'),
    meta: { title: '钉钉登录' }
  }
  ]
}

// 生成静态路由
const constantRoutes = getConstantRoutes()

// 根据权限过滤路由
const filterAsyncRoutes = (asyncRoutes, permissions) => {
  const res = []

  asyncRoutes.forEach(route => {
    const tmp = { ...route }
    // 检查该路由是否在权限列表中
    const hasPermission = permissions.some(permission =>
      permission.path === tmp.path
    )

    if (hasPermission) {
      // 如果有子路由，递归处理
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, permissions)
      }
      res.push(tmp)
    }
  })

  return res
}

// 初始化路由
const createDynamicRouter = () => {
  // 从localStorage获取路由权限
  const routersStr = localStorage.getItem('routers')
  let finalRoutes = [...constantRoutes]

  // if (routersStr) {
  //   const permissions = JSON.parse(routersStr)

  //   // 根据权限过滤asyncRoutes
  //   const accessRoutes = []

  //   // 遍历permissions，根据path添加对应的动态路由
  //   permissions.forEach(permission => {
  //     // 根据不同的path添加不同的路由对象
  //     if (permission.path === '/interview-demand') {
  //       // 添加与interview-demand相关的路由
  //       const relatedRoutes = asyncRoutes.filter(route =>
  //         ['/flow-config', '/post-template', '/ability', '/grade',
  //           '/question', '/experience-tag', '/test', '/interview-demand'].includes(route.path)
  //       )
  //       accessRoutes.push(...relatedRoutes)
  //     }
  //     else if (permission.path === '/my-interview-home') {
  //       // 添加与my-interview-home相关的路由
  //       const relatedRoutes = asyncRoutes.filter(route =>
  //         ['/my-interview-home', '/intelligent-assessment'].includes(route.path)
  //       )
  //       accessRoutes.push(...relatedRoutes)
  //     }
  //     else if (permission.path === '/talents') {
  //       // 添加与talents相关的路由
  //       const relatedRoutes = asyncRoutes.filter(route =>
  //         ['/talents', '/talents-curriculum-vitae'].includes(route.path)
  //       )
  //       accessRoutes.push(...relatedRoutes)
  //     }
  //     else if (permission.path === '/data-report') {
  //       // 添加与data-report相关的路由
  //       const relatedRoutes = asyncRoutes.filter(route =>
  //         ['/data-report'].includes(route.path)
  //       )
  //       accessRoutes.push(...relatedRoutes)
  //     }
  //   })

  //   // 去重，避免重复添加路由
  //   const uniqueAccessRoutes = []
  //   const pathSet = new Set()

  //   accessRoutes.forEach(route => {
  //     if (!pathSet.has(route.path)) {
  //       pathSet.add(route.path)
  //       uniqueAccessRoutes.push(route)
  //     }
  //   })

  //   // 将过滤后的路由添加到主路由的children中
  //   const mainRoute = finalRoutes.find(route => route.path === '/')
  //   if (mainRoute) {
  //     mainRoute.children = [...mainRoute.children, ...uniqueAccessRoutes]
  //   }
  // }

  return createRouter({
    history: createWebHashHistory(),
    routes: finalRoutes,
    scrollBehavior(to, from, savedPosition) {
      if (to.hash) {
        return {
          el: to.hash,
          behavior: 'smooth'
        }
      } else if (savedPosition) {
        return savedPosition
      } else {
        return { top: 0 }
      }
    }
  })
}

// 创建路由实例
const router = createDynamicRouter()

// 需要排除的路由路径（不需要记录到localStorage的路由）
const excludedPaths = [
  '/login',
  '/lark-enterprise-entry',
  '/lark-enterprise-callback',
  '/wechat-enterprise-entry',
  '/social-callback',
  '/dingtalk-login',
  '/remote-window-login',
  '/electron-centre-home',
  '/electron-centre-guacamole-home',
  '/electron-centre-batch-home',
  '/electron-centre-synchronize-home',
  '/electron-workbench-home',
  '/electron-flow-home',
  '/electron-bootstrap',
  '/dingtalk-enterprise-entry'
]

// 路由守卫 - 在路由变化后记录当前路由到 localStorage
router.afterEach((to, from) => {
  // 排除不需要记录的路由
  if (!excludedPaths.includes(to.path)) {
    try {
      // 构建完整的路由信息（包括路径和查询参数）
      const routeInfo = {
        path: to.path,
        query: to.query,
        fullPath: to.fullPath,
        timestamp: Date.now()
      }
      
      // 存储到 localStorage
      localStorage.setItem('lastVisitedRoute', JSON.stringify(routeInfo))
      
      console.log('路由变化已记录:', routeInfo)
    } catch (error) {
      console.error('记录路由失败:', error)
    }
  }
})

// 根据权限动态添加路由
export const setupRouter = () => {
  // 从localStorage获取路由权限
  const routersStr = localStorage.getItem('routers')
  if (routersStr) {
    const permissions = JSON.parse(routersStr)

    // 根据权限过滤asyncRoutes
    const accessRoutes = []

    // 遍历permissions，根据path添加对应的动态路由
    permissions.forEach(permission => {
      // 根据不同的path添加不同的路由对象
      if (permission.path === '/interview-demand') {
        // 添加与interview-demand相关的路由
        const relatedRoutes = asyncRoutes.filter(route =>
          ['/flow-config', '/post-template', '/ability', '/grade',
            '/question', '/experience-tag', '/test', '/interview-demand'].includes(route.path)
        )
        accessRoutes.push(...relatedRoutes)
      }
      else if (permission.path === '/my-interview-home') {
        // 添加与my-interview-home相关的路由
        const relatedRoutes = asyncRoutes.filter(route =>
          ['/my-interview-home', '/intelligent-assessment'].includes(route.path)
        )
        accessRoutes.push(...relatedRoutes)
      }
      else if (permission.path === '/talents') {
        // 添加与talents相关的路由
        const relatedRoutes = asyncRoutes.filter(route =>
          ['/talents', '/talents-curriculum-vitae'].includes(route.path)
        )
        accessRoutes.push(...relatedRoutes)
      }
      else if (permission.path === '/data-report') {
        // 添加与data-report相关的路由
        const relatedRoutes = asyncRoutes.filter(route =>
          ['/data-report'].includes(route.path)
        )
        accessRoutes.push(...relatedRoutes)
      }
    })

    // 去重，避免重复添加路由
    const uniqueAccessRoutes = []
    const pathSet = new Set()

    accessRoutes.forEach(route => {
      if (!pathSet.has(route.path)) {
        pathSet.add(route.path)
        uniqueAccessRoutes.push(route)
      }
    })

    // 将过滤后的路由添加到主路由的children中
    const mainRoute = constantRoutes.find(route => route.path === '/')
    if (mainRoute) {
      mainRoute.children = [...mainRoute.children, ...uniqueAccessRoutes]
    }

    // 重新加载路由
    uniqueAccessRoutes.forEach(route => {
      router.addRoute('/', route)
    })
  }
}

// 导出路由实例和路由配置
export { router, asyncRoutes, constantRoutes }
export default router
